var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-systems"},[(_vm.gotIt || (_vm.property.active && _vm.property.cultSwitch_id !== null))?_c('SystemsPage'):(!_vm.gotIt || (!_vm.property.active || _vm.property.cultSwitch_id === null))?_c('BookingEngineDisabled',{on:{"gotItEvent":_vm.gotItClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }